import { Select, MenuItem } from "@material-ui/core";
import "./styles.css";
interface ICustomSelectProps<
    T,
    TValue extends string | number | readonly string[]
> {
    options: Array<T>;
    getKeyValue: (option: T) => TValue;
    optionRender: (option: T) => React.ReactNode;
    onChange?: (selected: TValue) => void;
    value?: TValue;
}

export default function CustomSelect<
    T,
    TValue extends string | number | readonly string[]
>(props: ICustomSelectProps<T, TValue>) {
    return (
        <Select
            className="form-control boots-select w-100"
            value={props.value}
            onChange={(e) => props.onChange?.(e.target.value as TValue)}
        >
            {props.options.map((o) => (
                <MenuItem
                    value={props.getKeyValue(o)}
                    key={props.getKeyValue(o).toString()}
                >
                    {props.optionRender(o)}
                </MenuItem>
            ))}
        </Select>
    );
}
// const LazyCustomSelect = withLazy(CustomSelect, {dataProp: 'options'})
// export default LazyCustomSelect;
